export default {
  common: {
    error: "Coś poszło nie tak",
    reload: "Przeładuj",
    errorNotification: "Zostaliśmy powiadomieni i naprawimy to jak najszybciej. Jeśli problem będzie się powtarzał, prosimy",
    contactUs: "Skontaktuj się z nami.",
    language: "Język",
    loading: "Ładowanie...",
    loadingText: "Ładowanie",
    save: "Zapisz",
    savedSuccessfully: "Pomyślnie Zapisano",
    saving: "Zapisywanie...",
    cancel: "Anuluj",
    edit: "Edytuj",
    delete: "Usuń",
    add: "Dodaj",
    search: "Szukaj",
    filter: "Filtruj",
    clear: "Wyczyść",
    preview: "Podgląd",
    default: "Domyślne: {{value}}",
    optional: "Opcjonalne",
    required: "Wymagane",
    noData: "Brak danych",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Lokalizacje",
      cities: "Miasta", 
      regions: "Regiony",
      countries: "Kraje",
      showOnMap: "Pokaż na mapie",
      addLocation: "Dodaj lokalizację"
    },
    welcome: {
      title: "Witamy w Locations So Super.",
      subtitle: "Wybierz sekcję z nawigacji, aby rozpocząć."
    }
  },

  // Cities section
  cities: {
    title: "Miasta",
    resourceSingular: "miasto",
    resourcePlural: "miasta",
    headings: {
      name: "Nazwa",
      status: "Status",
      locations: "Lokalizacje", 
      region: "Region",
      country: "Kraj"
    },
    breadcrumbs: {
      cities: "Miasta"
    }
  },

  // Countries section  
  countries: {
    title: "Kraje",
    resourceSingular: "kraj", 
    resourcePlural: "kraje",
    headings: {
      name: "Nazwa",
      status: "Status",
      locations: "Lokalizacje",
      cities: "Miasta",
      regions: "Regiony"
    },
    breadcrumbs: {
      countries: "Kraje"
    }
  },

  // Regions section
  regions: {
    title: "Regiony",
    resourceSingular: "region",
    resourcePlural: "regiony", 
    headings: {
      name: "Nazwa",
      status: "Status",
      locations: "Lokalizacje",
      cities: "Miasta",
      country: "Kraj"
    },
    breadcrumbs: {
      regions: "Regiony"
    }
  },

  // Map section
  map: {
    title: "Mapa",
    breadcrumbs: {
      locations: "Lokalizacje"
    }
  },

  // Import section
  import: {
    title: "Import CSV",
    breadcrumbs: {
      locations: "Lokalizacje"
    },
    new: {
      title: "Importuj lokalizacje przez CSV",
      description: "Pobierz przykładowy szablon CSV, aby zobaczyć przykład wymaganego formatu",
      sampleTemplate: "przykładowy szablon CSV",
      uploadAndContinue: "Prześlij i kontynuuj",
      abortOnError: "Przerwij przy błędzie",
      abortOnErrorHelp: "Jeśli wystąpi błąd, import zostanie przerwany, wyświetli błąd i żadne lokalizacje nie zostaną zaimportowane.",
      needHelp: "Potrzebujesz pomocy w importowaniu lokalizacji?"
    },
    show: {
      title: "Import CSV",
      youCanLeavePage: "Możesz opuścić tę stronę",
      backgroundMessage: "Twój import będzie nadal działał w tle",
      importProgress: "Postęp importu",
      imported: "Zaimportowane",
      suffix: "lokalizacje",
      importLog: "Log importu",
      cancelImport: "Anuluj import",
      cancelConfirmation: {
        title: "Anuluj import",
        message: "Czy na pewno chcesz anulować to zadanie importu? Tej akcji nie można cofnąć.",
        note: "Uwaga: Dla zadań w toku zadanie będzie musiało się zakończyć i zostanie usunięte zaraz po.",
        yesCancel: "Tak, anuluj import",
        noContinue: "Nie, kontynuuj import"
      },
      report: "Raport",
      failedLocations: "Nieudane lokalizacje",
      uploadAnother: "Prześlij inny CSV",
      backToLocations: "Powrót do lokalizacji",
      importSucceeded: "Import się powiódł",
      importFailed: "Import się nie powiódł"
    },
    messages: {
      uploadSuccess: "CSV zostało pomyślnie przesłane",
      uploadError: "Nie można przesłać CSV",
      pending: "Import jeszcze się nie rozpoczął",
      inProgress: "Import w toku",
      completed: "Import zakończony",
      invalidHeader: "Wymagane są następujące kolumny",
      invalidCsvFile: "Nieprawidłowy plik CSV",
      aborted: "Import przerwany",
      failed: "Import się nie powiódł",
      cancelled: "Import anulowany"
    },
    errors: {
      csvTooLarge: "CSV jest za duże",
      languageNotEnabled: "Język '{{language}}' nie jest włączony dla tego sklepu. Prosimy włączyć go najpierw w Ustawienia > Języki.",
      fieldNotTranslatable: "Pole '{{field}}' nie jest tłumaczalne. Pola tłumaczalne to: {{fields}}",
      locationError: "Lokalizacja ze slugiem: {{slug}} - {{error}}",
      planLimit: "Osiągnąłeś limit planu dla lokalizacji"
    }
  },

  // Location form
  location: {
    index: {
      title: "Lokalizacje",
      addLocation: "Dodaj lokalizację",
      import: "Import",
      noPrioritySet: "Brak ustawionego priorytetu",
      published: "Opublikowane",
      draft: "Szkic",
      resourceSingular: "lokalizacja",
      resourcePlural: "lokalizacje",
      headings: {
        name: "Nazwa",
        status: "Status", 
        city: "Miasto",
        region: "Region",
        country: "Kraj",
        priority: "Priorytet"
      }
    },
    form: {
      title: "Dodaj lokalizację",
      editTitle: "Edytuj lokalizację",
      basicInformation: "Podstawowe informacje",
      name: "Nazwa",
      namePlaceholder: "np. Cegły Briana",
      nameHelpDefault: "Domyślne: {{defaultName}}",
      details: "Szczegóły",
      description: "Opis",
      descriptionPlaceholder: "Powiedz klientom, co czyni tę lokalizację wyjątkową",
      address: "Adres",
      addressPlaceholder: "123 Główna Ulica, Miasto, Kraj",
      addressLine1: "Linia adresu 1",
      addressLine2: "Linia adresu 2",
      postalZipCode: "Kod pocztowy / ZIP",
      city: "Miasto",
      stateProvinceRegion: "Województwo / Prowincja / Region",
      country: "Kraj",
      phone: "Telefon",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "Email", 
      emailPlaceholder: "store@example.com",
      website: "Strona internetowa",
      websitePlaceholder: "https://www.example.com",
      image: "Obraz",
      imagePlaceholder: "Wprowadź URL obrazu",
      status: "Status",
      statusActive: "Aktywne",
      statusInactive: "Nieaktywne",
      statusDraft: "Szkic",
      priority: "Priorytet",
      priorityHelpText: "Lokalizacje o wyższym priorytecie pojawiają się pierwsze w wynikach wyszukiwania",
      findOnMapButton: "Znajdź na mapie"
    },
    validation: {
      addressNotFound: "Nie można znaleźć adresu",
      createSuccess: "Lokalizacja została pomyślnie utworzona", 
      updateSuccess: "Lokalizacja została pomyślnie zaktualizowana",
      checkFields: "Prosimy sprawdzić pola",
      findOnMap: "Prosimy znaleźć lokalizację na mapie przed zapisaniem"
    },
    errors: {
      loading: "Błąd ładowania lokalizacji"
    },
    actions: {
      save: "Zapisz lokalizację",
      delete: "Usuń lokalizację",
      preview: "Podgląd"
    },
    customFields: {
      title: "Pola niestandardowe",
      noCustomFields: "Brak skonfigurowanych pól niestandardowych",
      configureFields: "Skonfiguruj pola",
      emptyState: "Nie skonfigurowałeś jeszcze żadnych pól niestandardowych. Pola niestandardowe pozwalają dodawać dodatkowe informacje specyficzne dla potrzeb Twojego biznesu."
    },
    openingHours: {
      title: "Godziny otwarcia",
      checkboxLabel: "Ta lokalizacja ma godziny otwarcia i zamknięcia",
      statusOpen: "Otwarte",
      statusOpen24h: "Otwarte 24H",
      statusClosed: "Zamknięte",
      openingTimeLabel: "Godzina otwarcia",
      closingTimeLabel: "Godzina zamknięcia",
      days: {
        monday: "Poniedziałek",
        tuesday: "Wtorek", 
        wednesday: "Środa",
        thursday: "Czwartek",
        friday: "Piątek",
        saturday: "Sobota",
        sunday: "Niedziela"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Ostatnio dodane",
        recentlyModified: "Ostatnio zmodyfikowane"
      },
      filters: {
        status: "Status",
        taggedWith: "Otagowane",
        locationStatus: "Status lokalizacji",
        noTagsToShow: "Brak tagów do wyświetlenia",
        searchPlaceholder: "Szukaj"
      },
      bulkActions: {
        setPublished: "Ustaw jako opublikowane",
        setUnpublished: "Ustaw jako nieopublikowane", 
        setPriority: "Ustaw priorytet",
        deleteLocations: "Usuń lokalizacje",
        exportCSV: "Eksportuj jako CSV"
      },
      appliedFilters: {
        statusIs: "Status to {{status}}",
        taggedWith: "Otagowane {{tag}}",
        nameIncludes: "Nazwa zawiera {{search}}"
      },
      modals: {
        deleteTitle: "Usuń lokalizacje",
        deleteMessage: "Czy na pewno chcesz usunąć {{count}}?",
        deleteMessageAll: "Czy na pewno chcesz usunąć wszystkie lokalizacje?",
        prioritiseTitle: "Ustaw priorytet dla {{count}} lokalizacji",
        prioritiseTitleAll: "Ustaw priorytet dla wszystkich lokalizacji",
        delete: "Usuń",
        cancel: "Anuluj"
      },
      emptyState: {
        noResultsHeading: "Nie znaleziono żadnych {{resourcePlural}}",
        noResultsText: "Spróbuj zmienić filtry lub termin wyszukiwania",
        noDataHeading: "Dodaj lokalizację, aby wypełnić {{resourcePlural}}",
        addLocation: "Dodaj lokalizację",
        importFromCSV: "Importuj z CSV"
      },
      pagination: {
        label: "Strona {{page}} z {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Pomyślnie zaktualizowano",
        deletedSuccessfully: "Pomyślnie usunięto", 
        exportedSuccessfully: "Pomyślnie wyeksportowano",
        error: "Coś poszło nie tak"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Zawartość strony",
    editTemplate: "Edytuj szablon SEO", 
    pageTitle: "Tytuł",
    pageDescription: "Opis",
    metaTitle: "Tytuł",
    metaDescription: "Opis",
    urlHandle: "Uchwyt URL",
    searchEnginePreview: "Podgląd listy wyszukiwarki",
    editMeta: "Edytuj Meta",
    previewMeta: "Podgląd Meta",
    loading: "Ładowanie...",
    editingLocaleHelp: "Edytowanie zawartości {{locale}}."
  },

  // SEO Templates section
  seoTemplates: {
    title: "Szablony SEO",
    breadcrumbs: {
      seoTemplates: "Szablony SEO"
    },
    template: {
      title: "Szablon {{templateName}} - {{locale}}",
      discardChanges: "Odrzuć zmiany"
    },
    form: {
      pageContent: "Zawartość strony",
      searchEnginePreview: "Podgląd listy wyszukiwarki",
      title: "Tytuł",
      description: "Opis",
      pageTitle: "Tytuł strony",
      metaDescription: "Meta opis",
      editingLocaleHelp: "Edytowanie tłumaczeń {{locale}}. Puste pola będą wyświetlać zawartość z {{defaultLocale}}.",
      defaultValue: "Domyślne: {{value}}"
    },
    language: {
      label: "Język",
      defaultHelp: "To jest Twój domyślny język",
      editingHelp: "Edytowanie tłumaczeń {{locale}}. Puste pola będą pokazywać zawartość {{defaultLocale}}."
    },
    banner: {
      multipleLanguagesDisabled: "Wiele języków nie włączone",
      enableInSettings: "Włącz w Ustawieniach",
      multipleLanguagesInfo: "Aby zarządzać szablonami SEO dla wielu języków, włącz internacjonalizację w ustawieniach języka. Obecnie pokazują się tylko szablony {{locale}}."
    },
    badges: {
      errors: "Błędy!",
      unsaved: "Niezapisane"
    },
    messages: {
      saveSuccess: "Szablony SEO zostały pomyślnie zapisane",
      saveError: "Nie można zapisać szablonów",
      error: "Błąd..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Podstawowe informacje",
      name: "Nazwa",
      save: "Zapisz",
      saving: "Zapisywanie...",
      cancel: "Anuluj",
      yourLocationsIn: "Twoje lokalizacje w {{name}}",
      tableHeadings: {
        name: "Nazwa",
        status: "Status",
        city: "Miasto",
        region: "Region",
        country: "Kraj"
      },
      resourceName: {
        singular: "lokalizacja {{name}}",
        plural: "lokalizacje w {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Mapa",
      tags: "Tagi",
      customFields: "Pola niestandardowe",
      languages: "Języki",
      plan: "Plan",
      addTag: "Dodaj tag",
      addField: "Dodaj pole"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Kończy się wkrótce"
    },
    common: {
      loading: "Ładowanie...",
      error: "Błąd...",
      breadcrumbs: {
        settings: "Ustawienia"
      },
      skeleton: {
        customFields: "Pola niestandardowe",
        addField: "Dodaj pole",
        name: "Nazwa",
        contentType: "Typ zawartości",
        usedIn: "Używane w",
        field: "Pole",
        fields: "Pola"
      },
      messages: {
        savedSuccessfully: "Ustawienia {{setting}} zostały pomyślnie zapisane",
        couldntSave: "Nie można zapisać ustawień {{setting}}"
      }
    },
    map: {
      title: "Mapa",
      messages: {
        savedSuccessfully: "Ustawienia mapy zostały pomyślnie zapisane",
        couldntSave: "Nie można zapisać ustawień"
      },
      mapboxToken: {
        title: "Token Mapbox",
        description: "Wprowadź swój token Mapbox, aby zasilić lokalizator sklepów",
        label: "Token Mapbox",
        placeholder: "Wprowadź token tutaj, aby kontynuować korzystanie z mapy.",
        placeholderManaged: "Wprowadź token tutaj, aby kontynuować korzystanie z mapy po wyczerpaniu darmowych obciążeń mapy.",
        helpText: "Postępuj zgodnie z naszymi instrukcjami tworzenia klucza Mapbox, a następnie wklej swój klucz powyżej. Jeśli napotkasz problemy, skontaktuj się z nami w celu uzyskania pomocy.",
        linkInstructions: "instrukcje tworzenia klucza Mapbox",
        linkSupport: "skontaktuj się z nami w celu uzyskania pomocy"
      },
      managedToken: {
        title: "Obciążenia mapy",
        description: "Masz do {{max}} darmowych obciążeń mapy z zarządzanym tokenem, po czym będziesz musiał utworzyć własny token."
      },
      appearance: {
        title: "Wygląd",
        description: "Zmień wizualny wygląd mapy"
      },
      mapStyle: {
        title: "Styl mapy",
        options: {
          streets: "Ulice",
          outdoors: "Na zewnątrz", 
          light: "Jasny",
          dark: "Ciemny",
          satellite: "Satelita",
          satelliteStreets: "Ulice satelitarne",
          navigationDay: "Nawigacja dzienna",
          navigationNight: "Nawigacja nocna"
        }
      },
      searchBehaviour: {
        title: "Zachowanie wyszukiwania",
        description: "Kontroluje, jak odwiedzający znajdują lokalizacje na mapie.",
        geolocateLabel: "Automatycznie oszacuj lokalizację odwiedzającego i pokaż pobliskie sklepy",
        geolocateHelp: "Jeśli geolokalizacja się powiedzie, mapa przesunie się, aby skupić się w pobliżu odwiedzającego. Jeśli nie można znaleźć szacowanej lokalizacji, mapa pozostanie w pozycji początkowej.",
        filterBehaviour: {
          title: "Zachowanie filtra",
          all: {
            label: "Wszystkie tagi",
            help: "Aby lokalizacja pojawiła się w filtrach, musi mieć wszystkie wybrane tagi"
          },
          any: {
            label: "Dowolne tagi", 
            help: "Aby lokalizacja pojawiła się w filtrach, może mieć dowolny z wybranych tagów"
          }
        },
        keepSearchInView: {
          label: "Zachowaj marker wyszukiwania w widoku",
          help: "Gdy pojawią się wyniki wyszukiwania, mapa oddali się, aby pokazać wszystkie pasujące lokalizacje"
        },
        distanceUnits: {
          title: "Jednostki odległości",
          km: "Kilometry",
          miles: "Mile"
        },
        maxResults: {
          label: "Maksymalne wyniki",
          help: "Ogranicz liczbę lokalizacji pokazywanych w wynikach wyszukiwania",
          options: {
            results30: "30 wyników"
          }
        },
        maxDistance: {
          label: "Maksymalna odległość", 
          help: "Pokaż tylko lokalizacje w tej odległości od punktu wyszukiwania",
          options: {
            unlimited: "Nieograniczone"
          }
        },
        showLocationNames: {
          label: "Pokaż nazwy lokalizacji w sugestiach",
          help: "Wyświetl nazwy lokalizacji w sugestiach wyszukiwania"
        },
        sortByPriority: {
          label: "Sortuj według priorytetu zamiast odległości",
          help: "Zaleca się ustawienie maksymalnej odległości (która nie jest Nieograniczona), jeśli to pole jest zaznaczone. W przeciwnym razie klienci zobaczą odległe lokalizacje o wysokim priorytecie wymienione powyżej tych, które znajdują się w rozsądnej odległości od nich (lub ich zapytania wyszukiwania, bardziej szczegółowo)."
        }
      },
      searchResults: {
        title: "Wyniki wyszukiwania",
        description: "Kontroluje, jak lokalizacje są zwracane na mapie.",
        locationsLabel: "Tekst wyników wyszukiwania",
        locationsHelp: "Tekst pokazywany nad wynikami wyszukiwania (np. 'Pokazuję 5 lokalizacji')",
        prefixLabel: "Prefiks wyników wyszukiwania", 
        prefixHelp: "Tekst pokazywany przed liczbą wyników"
      },
      popups: {
        title: "Wyskakujące okienka",
        showPopups: {
          label: "Pokaż wyskakujące okienka",
          help: "Wyświetl szczegóły lokalizacji, gdy odwiedzający klikną na markery mapy"
        }
             },
       whitelabel: {
         title: "Biała etykieta",
         hideLabel: "Ukryj tekst 'powered by'",
         hideHelp: "Usuń nasze branding z lokalizatora sklepów"
       }
    },
    languages: {
      title: "Języki",
      error: "Błąd...",
      messages: {
        savedSuccessfully: "Ustawienia języka zostały pomyślnie zapisane",
        couldntSave: "Nie można zapisać ustawień języka"
      },
      banner: {
        upgradeTitle: "Obsługa wielu języków wymaga aktualizacji planu",
        upgradeAction: "Aktualizuj do Superest",
        upgradeMessage: "Możesz nadal zmieniać domyślny język, ale włączenie wielu języków wymaga aktualizacji.",
        disabledMessage: "Ustawienia wielu języków są wyłączone w obecnym planie"
      },
      defaultLanguage: {
        title: "Domyślny język", 
        description: "Wybierz swój główny język, w którym będzie wyświetlana treść.",
        label: "Domyślny język",
        help: "Ten język będzie używany, gdy nie zostanie zażądany konkretny język"
      },
      internationalization: {
        title: "Internacjonalizacja",
        description: "Włącz wiele języków. Dotrzyj do większej liczby klientów i zwiększ SEO.",
        enableLabel: "Włącz wiele języków",
        enableHelp: "Pozwól klientom przeglądać lokalizator sklepów w różnych językach"
      },
      supportedLanguages: {
        title: "Dodatkowe obsługiwane języki",
        description: "Wybierz dodatkowe języki, które chcesz obsługiwać. Po włączeniu języka zobaczysz opcję dostarczania tłumaczeń w całej aplikacji. Dla obsługiwanych języków domyślne szablony SEO oraz wspólne zmienne motywy zostaną wygenerowane automatycznie.",
        defaultLocaleNote: "To jest twój domyślny język i nie może być wyłączony",
        shopifyEnabled: {
          label: "Ten język jest włączony w moim sklepie Shopify",
          importantNote: "Ważne:",
          description: "Odznacz powyższe pole, jeśli ten język nie jest włączony i opublikowany dla twojego sklepu Shopify. Zaleca się najpierw włączenie języka dla sklepu Shopify, przechodząc do Ustawienia > Języki w panelu administracyjnym Shopify, jeśli jeszcze tego nie zrobiłeś dla płynniejszego doświadczenia klienta."
        },
        urlFormats: {
          cleanUrls: "Czyste URL:",
          betterSeo: "Lepsze SEO i doświadczenie użytkownika",
          queryUrls: "URL z parametrami zapytania:",
          considerEnabling: "Rozważ włączenie w Shopify dla lepszych URL"
        },
        preview: {
          button: "Podgląd",
          tooltip: "Podgląd lokalizatora sklepów {{language}}"
        },
        tooltips: {
          noTemplates: "Brak domyślnych szablonów SEO dostępnych dla tego języka. Możesz łatwo tworzyć niestandardowe tłumaczenia."
        }
      }
    },
    tags: {
      title: "Tagi",
      addTag: "Dodaj tag",
      error: "Błąd",
      messages: {
        deletedSuccessfully: "Tagi zostały pomyślnie usunięte",
        couldntDelete: "Nie można usunąć tagów",
        savedSuccessfully: "Tag został pomyślnie zapisany",
        couldntSave: "Sprawdź swoje pola",
        tagDeleted: "Tag został pomyślnie usunięty"
      },
      resourceName: {
        singular: "tag",
        plural: "tagi"
      },
      filters: {
        anyGroup: "Dowolna grupa",
        inGroup: "W grupie",
        tagGroup: "Grupa tagów"
      },
      appliedFilters: {
        inGroup: "W grupie {{group}}",
        nameContains: "Nazwa tagu zawiera {{query}}"
      },
      bulkActions: {
        deleteTag: "Usuń tag",
        deleteTags: "Usuń tagi"
      },
      form: {
        language: "Język",
        title: "Tytuł",
        description: "Opis",
        group: "Grupa",
        groupPlaceholder: "Wybierz grupę",
        addGroup: "Dodaj",
        editingTranslations: "Edytowanie tłumaczeń {{language}}. Puste pola będą wyświetlać treść z {{defaultLanguage}}.",
        defaultValue: "Domyślne: {{value}}",
        image: "Obraz",
        imageUrl: "URL obrazu"
      },
      actions: {
        save: "Zapisz",
        deleteTag: "Usuń tag"
      },
      new: {
        title: "Dodaj tag",
        messages: {
          createSuccess: "Tag został pomyślnie utworzony",
          checkFields: "Sprawdź swoje pola"
        },
        actions: {
          createTag: "Utwórz tag"
        }
      }
    },
    customFields: {
      title: "Niestandardowe pola",
      addField: "Dodaj pole",
      error: "Błąd",
      resourceName: {
        singular: "Pole",
        plural: "Pola"
      },
      headings: {
        name: "Nazwa",
        contentType: "Typ zawartości",
        usedIn: "Używane w"
      },
      emptyState: {
        heading: "Twórz i zarządzaj niestandardowymi polami",
        createAction: "Utwórz pole",
        description: "Używaj niestandardowych pól dla unikalnych atrybutów dotyczących lokalizacji. Te pola mogą być czymkolwiek od profili społecznościowych po nazwę i email menedżera sklepu"
      },
      pluralization: {
        location: "lokalizacja",
        locations: "lokalizacje"
      },
      form: {
        name: "Nazwa",
        contentType: "Typ zawartości",
        key: "Klucz",
        keyPrefix: "location.fields.",
        keyHelp: "Użyj tego klucza, aby uzyskać dostęp do zawartości {{name}} lokalizacji w szablonach liquid.",
        translations: {
          title: "Tłumaczenia",
          showTranslations: "Pokaż tłumaczenia",
          hideTranslations: "Ukryj tłumaczenia",
          description: "Tłumaczenia są opcjonalne. Puste pola będą wyświetlać nazwę pola {{language}}.",
          nameTranslation: "Nazwa ({{language}})",
          defaultValue: "Domyślne: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Pole zostało pomyślnie zapisane",
        couldntSave: "Nie można zapisać pola",
        deletedSuccessfully: "Pole zostało pomyślnie usunięte",
        couldntDelete: "Nie można usunąć pola"
      },
      actions: {
        delete: "Usuń"
      },
      new: {
        title: "Dodaj pole",
        messages: {
          savedSuccessfully: "Pole zostało pomyślnie zapisane",
          couldntSave: "Nie można zapisać pola"
        }
      },
      contentTypes: {
        text: "Tekst",
        textArea: "Obszar tekstu", 
        email: "Email",
        number: "Liczba",
        phoneNumber: "Numer telefonu",
        time: "Czas",
        url: "URL"
      }
    },
    plan: {
      title: "Plan",
      error: "Błąd",
      changePlan: "Zmień plan",
      usdPerMonth: "USD / miesiąc",
      sections: {
        yourPlanIncludes: "Twój plan obejmuje",
        nextBillingDate: "Następna data rozliczenia",
        trial: "Próba"
      },
      banners: {
        planUpdated: "Twój plan został zaktualizowany",
        thankYouUpgrading: "Dziękujemy za aktualizację!",
        letUsKnow: "Daj nam znać",
        improvementText: "jeśli jest coś, co możemy zrobić lepiej.",
        trialCancellation: {
          title: "Powiadomienie o anulowaniu okresu próbnego",
          message: "Twój 14-dniowy bezpłatny okres próbny zostanie anulowany po przejściu na płatny plan."
        }
      },
      locations: {
        upTo: "Do",
        locations: "lokalizacji",
        unlimited: "Nieograniczone lokalizacje",
        used: "używane",
        ofUsed: "{{used}} z {{max}} używane"
      },
      trial: {
        daysLeft: "Pozostało {{days}} dni",
        daysUsed: "{{used}} z {{total}} dni użyte",
        selectPlan: "Wybierz plan",
        currentPlan: "Obecny plan",
        trialBadge: "Próba",
        currentBadge: "Obecny",
        yourTrialJustStarted: "Twoja próba właśnie się rozpoczęła",
        trialEndsAfterToday: "Twoja próba kończy się po dzisiejszym dniu",
        trialEndsTomorrow: "Twoja próba kończy się jutro",
        daysLeftInTrial: "Pozostało {{days}} dni w twojej próbie",
        continueAddingLocations: "Kontynuuj dodawanie lokalizacji po {{date}} wybierając plan",
        selectPlanToday: "Proszę wybrać plan dzisiaj, aby kontynuować dodawanie lokalizacji"
      },
      footer: {
        description: "Zarządzaj lub zmień swój plan Locations So Super. Zobacz nasze",
        termsOfService: "warunki świadczenia usług",
        and: "i",
        privacyPolicy: "politykę prywatności"
      },
      features: {
        analytics: {
          title: "Analityka",
          description: "Dowiedz się, jak ludzie korzystają z twoich lokalizacji i gdzie szukają"
        },
        internationalization: {
          title: "Obsługa wielu języków",
          description: "Zwiększ SEO i dotrzyj do większej liczby klientów na rynkach docelowych, włączając wiele języków"
        },
        customThemes: {
          editLiquid: {
            title: "Edytuj szablony liquid motywu",
            description: "Wyświetl dane lokalizacji w dowolny sposób z dostępem do liquid motywu"
          },
          editStructuredData: {
            title: "Edytuj strukturalne dane biznesowe",
            description: "Edytuj sposób, w jaki Google rozumie strony, edytując swoje strukturalne dane"
          }
        }
      },
      edit: {
        title: "Zmień plan",
        allPlansInclude: "Wszystkie plany powyżej obejmują",
        needingMoreLocations: "Potrzebujesz więcej lokalizacji?",
        footerQuestion: "Masz pytania przed rozpoczęciem?",
        sendMessage: "wyślij nam wiadomość",
        allFeatures: {
          seoDirectory: {
            title: "Katalog SEO i strony docelowe",
            description: "Automatycznie utwórz katalog SEO wszystkich lokalizacji, miast i regionów"
          },
          mapPage: {
            title: "Strona mapy z wyszukiwaniem i filtrowaniem",
            description: "Wyszukuj i filtruj wszystkie lokalizacje na mapie zasilanej przez mapbox"
          },
          tags: {
            title: "Tagi",
            description: "Twórz tagi z obrazami i opisami oraz grupuj je"
          },
          openingHours: {
            title: "Godziny otwarcia",
            description: "Ustaw i wyświetl godziny otwarcia dla lokalizacji"
          },
          mapStyles: {
            title: "Style mapy",
            description: "Zmień wygląd map z wieloma wstępnie ustawionymi stylami"
          },
          customFields: {
            title: "Niestandardowe pola",
            description: "Dodaj dowolne nowe pola, od linków społecznościowych po menedżera sklepu"
          },
          csvUpload: {
            title: "Prześlij i eksportuj z CSV",
            description: "Prześlij i edytuj zbiorczo lokalizacje."
          },
          richSnippets: {
            title: "Bogate fragmenty",
            description: "Pomóż Google lepiej rozumieć strony z strukturalnymi danymi lokalnego biznesu"
          },
          directionsAndCalls: {
            title: "Kierunki i połączenia",
            description: "Odwiedzający mogą łatwo uzyskać kierunki i dzwonić do lokalizacji"
          },
          languageSupport: {
            title: "Obsługa języka",
            description: "Zmień domyślny język na coś innego niż angielski. Szablony tłumaczeń dostępne dla 32 głównych języków dla łatwej konfiguracji."
          }
        }
      },
      planCard: {
        bestToCustomize: "Najlepsze do dostosowania",
        currentPlan: "Obecny plan",
        chooseThisPlan: "Wybierz ten plan",
        locationsSection: "Lokalizacje",
        featuresSection: "Funkcje",
        upTo: "Do",
        locations: "lokalizacji",
        tooltipTooManyLocations: "Masz zbyt wiele lokalizacji i/lub włączonych języków dla tego planu."
      },
      confirmation: {
        error: "Błąd potwierdzania planu"
      }
    }
  },

  // Themes section
  themes: {
    title: "Motywy",
    currentTheme: {
      title: "Obecny motyw",
      description: "To jest motyw, który klienci widzą, gdy odwiedzają aplikację lokalizacji."
    },
    themeLibrary: {
      title: "Biblioteka motywów", 
      description: "Zarządzaj motywami lokalizacji. Dodawaj i publikuj motywy, aby zmienić wygląd online lokalizacji."
    },
    skeleton: {
      currentThemeDescription: "To jest motyw, który twoi klienci widzą, gdy używają aplikacji lokalizacji."
    },
    modal: {
      overrideTitle: "Nadpisać obecny motyw?",
      override: "Nadpisz",
      cancel: "Anuluj",
      undoWarning: "Tej akcji nie można cofnąć."
    },
    messages: {
      publishSuccess: "Motyw został pomyślnie opublikowany",
      publishError: "Nie można opublikować motywu",
      error: "Coś poszło nie tak"
    },
    emptyStates: {
      settings: {
        heading: "Ten motyw nie ma ustawień",
        description: "Utwórz ustawienia w edytorze szablonów.",
        createSettings: "Utwórz ustawienia",
        upgradePlan: "Aktualizuj plan",
        upgradeRequired: "Aktualizuj plan, aby utworzyć ustawienia"
      },
      language: {
        heading: "Ten motyw nie ma terminów językowych",
        description: "Utwórz terminy językowe w edytorze szablonów.",
        createLanguageTerms: "Utwórz terminy językowe",
        upgradePlan: "Aktualizuj plan",
        upgradeRequired: "Aktualizuj plan, aby utworzyć terminy językowe"
      }
    },
    templates: {
      categories: {
        templates: "Szablony",
        schemas: "Schematy",
        styles: "Style",
        liquidReference: "Referencja Liquid"
      },
      items: {
        landing: "Docelowa",
        directory: "Katalog",
        country: "Kraj",
        region: "Region",
        city: "Miasto",
        location: "Lokalizacja",
        language: "Język",
        settings: "Ustawienia",
        stylesheet: "Arkusz stylów"
      },
      errors: {
        errorsInTemplate: "Błędy w szablonie",
        error: "Błąd"
      },
      badges: {
        errors: "Błędy!",
        unsaved: "Niezapisane"
      },
      actions: {
        viewTheme: "Zobacz motyw",
        discard: "Odrzuć",
        save: "Zapisz"
      }
    },
    language: {
      messages: {
        saveSuccess: "Tłumaczenia języka motywu zostały pomyślnie zapisane",
        saveError: "Motyw nie mógł zapisać"
      },
      form: {
        language: "Język",
        defaultLanguageHelp: "To jest twój domyślny język",
        translationHelp: "Edytowanie tłumaczeń dla {{selectedLocale}}. Puste pola będą wyświetlać treść z {{defaultLocale}} (twój domyślny język)."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Wiele języków nie włączone",
          action: "Włącz w ustawieniach",
          description: "Aby zarządzać tłumaczeniami dla wielu języków, włącz internacjonalizację w ustawieniach języka. Obecnie pokazuję tylko tłumaczenia {{locale}}."
        },
        translating: {
          title: "Tłumaczenie z {{from}} na {{to}}",
          description: "Każde pole, które pozostawisz puste, automatycznie wyświetli treść {{defaultLocale}} klientom. Tłumacz tylko pola, w których chcesz inną treść w {{selectedLocale}}."
        }
      },
      accessLanguageTerms: "Uzyskaj dostęp do terminów językowych {{category}} w liquid z {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Tytuł",
        description: "Opis",
        heading: "Nagłówek",
        subheading: "Podtytuł",
        button_text: "Tekst przycisku",
        link_text: "Tekst linku",
        placeholder: "Symbol zastępczy",
        label: "Etykieta",
        help_text: "Tekst pomocy",
        error_message: "Komunikat błędu",
        success_message: "Komunikat sukcesu",
        
        // Opening hours
        Monday: "Poniedziałek",
        Tuesday: "Wtorek",
        Wednesday: "Środa",
        Thursday: "Czwartek",
        Friday: "Piątek",
        Saturday: "Sobota",
        Sunday: "Niedziela",
        opening_hours_format: "Format godzin otwarcia",
        closes_at_format: "Format zamykania o",
        opens_at_format: "Format otwierania o",
        opens_on: "Otwiera się w",
        open_24h: "Otwarte 24h",
        open: "Otwarte",
        closed: "Zamknięte",
        closes_at: "Zamyka się o",
        opens_at: "Otwiera się o",
        
        // Map
        search_map: "Szukaj na mapie",
        search_area: "Szukaj w tym obszarze",
        view_map: "Mapa",
        view_list: "Lista",
        open_filters: "Filtry",
        stores_near_you: "Sklepy w pobliżu",
        header: "Znajdź sklep!",
        search_placeholder: "Wpisz kod pocztowy lub adres...",
        no_listings: "Przepraszamy, nie możemy znaleźć żadnych lokalizacji dla twojego wyszukiwania. Spróbuj zmienić filtry lub lokalizację wyszukiwania",
        
        // Directory
        view_directory: "Katalog sklepów",
        
        // Location
        get_directions: "Kierunki",
        call: "Zadzwoń",
        view_website: "Strona internetowa",
        email: "Email",
        opening_hours_header: "Godziny otwarcia",
        description_header: "Informacje",
        phone_number_header: "Telefon",
        address_header: "Adres",
        tag_groups_to_display: "Grupy tagów do wyświetlenia"
      },
              categories: {
          // Common language categories - add specific ones as needed
          general: "Ogólne",
          navigation: "Nawigacja",
          forms: "Formularze",
          buttons: "Przyciski",
          messages: "Wiadomości",
          errors: "Błędy",
          opening_hours: "Godziny otwarcia",
          map: "Mapa",
          directory: "Katalog",
          location: "Lokalizacja"
        }
    },
    settings: {
      messages: {
        saveSuccess: "Motyw został pomyślnie zapisany",
        saveError: "Motyw nie mógł zapisać"
      },
      accessSettings: "Uzyskaj dostęp do ustawień {{category}} w liquid z {{code}}",
      fields: {
        // Colors
        color_text: "Kolor tekstu",
        color_text_heading: "Kolor nagłówka tekstu", 
        color_background: "Kolor tła",
        color_accent: "Kolor akcentu",
        color_text_positive: "Kolor tekstu pozytywnego",
        color_text_negative: "Kolor tekstu negatywnego",
        dark_theme: "Ciemny motyw",
        color_marker: "Kolor markera",
        color_search_marker: "Kolor markera wyszukiwania",
        
        // Typography
        base_font_size: "Podstawowy rozmiar czcionki",
        
        // Buttons
        border_radius: "Promień obramowania",
        
        // Images
        aspect_ratio: "Proporcje",
        fit: "Dopasowanie",
        
        // Spacing
        page_width: "Szerokość strony",
        page_width_small: "Szerokość strony mała",
        gutter_desktop: "Korytarz desktop",
        gutter_mobile: "Korytarz mobilny",
        desktop_vertical_spacing: "Pionowe odstępy desktop",
        mobile_vertical_spacing: "Pionowe odstępy mobilne",
        
        // Breakpoints
        breakpoint_xs: "Punkt przerwania XS",
        breakpoint_sm: "Punkt przerwania SM",
        breakpoint_md: "Punkt przerwania MD",
        
        // Map
        search_on_move: "Szukaj przy ruchu",
        scroll_to_zoom: "Przewiń, aby powiększyć",
        
        // Landing page
        sidebar_width: "Szerokość paska bocznego",
        sidebar_min_height: "Minimalna wysokość paska bocznego",
        marker_image_src: "Źródło obrazu markera",
        show_filter_descriptions: "Pokaż opisy filtrów",
        
        // Location page
        tag_groups_to_display: "Grupy tagów do wyświetlenia",
        tag_groups_to_display_as_icons: "Grupy tagów do wyświetlenia jako ikony",
        show_related_locations: "Pokaż powiązane lokalizacje",
        
        // Locations
        hide_regions: "Ukryj regiony"
      },
      categories: {
        colors: "Kolory",
        typography: "Typografia",
        buttons: "Przyciski",
        images: "Obrazy",
        spacing: "Odstępy",
        breakpoints: "Punkty przerwania",
        map: "Mapa",
        landing_page: "Strona docelowa",
        location_page: "Strona lokalizacji",
        locations: "Lokalizacje"
      }
    },
    navigation: {
      sublimeTheme: "Motyw Sublime",
      settings: "Ustawienia",
      language: "Język",
      templates: "Szablony",
      changeTheme: "Zmień motyw",
      viewDirectory: "Zobacz katalog",
      viewLandingPage: "Zobacz stronę docelową"
    },
    card: {
      lastUpdated: "Ostatnio zaktualizowane",
      view: "Zobacz",
      customize: "Dostosuj",
      publish: "Opublikuj",
      actions: "Akcje"
    }
  },

  // Analytics section
  analytics: {
    title: "Analityka",
    timePeriods: {
      last7days: "Ostatnie 7 dni",
      last30days: "Ostatnie 30 dni"
    },
    comparison: {
      compareToPrevious: "Porównaj z poprzednim okresem",
      stopComparing: "Przestań porównywać z poprzednim okresem"
    },
    sections: {
      searchLocations: "Szukaj lokalizacji"
    },
    cards: {
      sessions: "Sesje",
      topSearches: "Najlepsze wyszukiwania",
      topLandingPageType: "Najlepszy typ strony docelowej",
      topPageViewsBySession: "Najlepsze wyświetlenia stron według sesji",
      topLocations: "Najlepsze lokalizacje",
      topReferrers: "Najlepsze źródła ruchu",
      searches: "Wyszukiwania",
      topLandingPagesBySession: "Najlepsze strony docelowe według sesji"
    },
    chartLabels: {
      desktop: "Desktop"
    }
  },

}; 